'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _isNull = require('lodash/isNull');

var _isNull2 = _interopRequireDefault(_isNull);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ajaxOptions(url, options) {
  var baseOptions = {
    url: url,
    method: options.method,
    responseType: 'json'
  };

  if (options.headers) baseOptions.headers = options.headers;

  if (options.method === 'GET' && options.data) {
    url = url + '?' + _qs2.default.stringify(options.data, options.qs);

    return Object.assign({}, baseOptions, { url: url });
  }

  var formData = new FormData();
  var hasFile = false;

  (0, _forEach2.default)(options.data, function (val, attr) {
    hasFile = hasFile || val instanceof File || val instanceof Blob;

    if (!(0, _isNull2.default)(val)) formData.append(attr, val);
  });

  if (hasFile) {
    return Object.assign({}, baseOptions, {
      cache: false,
      processData: false,
      data: formData
    });
  }

  return Object.assign({}, baseOptions, { data: options.data });
}


function ajax(url, options, axiosInstance) {
  var CancelToken = axiosInstance.CancelToken;

  var cancel = void 0;

  var xhr = axiosInstance(ajaxOptions(url, options), {
    cancelToken: new CancelToken(function (c) {
      cancel = c;
    })
  });

  var promise = new Promise(function (resolve, reject) {
    xhr.then(function (response) {
      return resolve(response.data);
    }, function (error) {
      return reject(error.response);
    });
  });

  var abort = function abort() {
    cancel();
  };

  return { abort: abort, promise: promise };
}

exports.default = function (axiosInstance) {
  return {
    apiPath: '',
    commonOptions: {},

    get: function get(path, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return ajax('' + this.apiPath + path, (0, _merge2.default)({}, { method: 'GET', data: data }, this.commonOptions, options), axiosInstance);
    },
    post: function post(path, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return ajax('' + this.apiPath + path, (0, _merge2.default)({}, { method: 'POST', data: data }, this.commonOptions, options), axiosInstance);
    },
    put: function put(path, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return ajax('' + this.apiPath + path, (0, _merge2.default)({}, { method: 'PUT', data: data }, this.commonOptions, options), axiosInstance);
    },
    patch: function patch(path, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return ajax('' + this.apiPath + path, (0, _merge2.default)({}, { method: 'PATCH', data: data }, this.commonOptions, options), axiosInstance);
    },
    del: function del(path) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return ajax('' + this.apiPath + path, (0, _merge2.default)({}, { method: 'DELETE' }, this.commonOptions, options), axiosInstance);
    }
  };
};